import React, { useState, useEffect, useContext, useImperativeHandle } from 'react';

import { useSDK } from "../../scandit/sdk";
import ScannerComponent from "../../scandit/ScannerComponent";

// import * as SDCCore from "scandit-web-datacapture-core";
// import * as SDCBarcode from "scandit-web-datacapture-barcode";
// import { DataCaptureContext,FrameSourceState, Camera } from "scandit-web-datacapture-core";
// import { barcodeCaptureLoader } from "scandit-web-datacapture-barcode";


import styles from '../../styles/BarcodeScanner.module.scss';
import {AnimatePresence, motion} from 'framer-motion';
import { useUserAPI } from '../../components/useUserAPI';
import { ShoppingStart } from '../../components/ShoppingStart';
import { SharedInfoContext } from '../../components/SharedInfoContextProvider';

//お買物API
import { callOkaimonoAPI } from "../../components/okaimonoAPI";

// import useSound from 'use-sound';
// import se_07_scan from '../../sound/s07_scan.mp3';
// import se_08 from '../../sound/s08_se_delay0.mp3';

const BarcodeScanner = React.forwardRef((props, ref) => {


//----------------------------------------
// scandit
//----------------------------------------

const { loaded, sdk, error } = useSDK();

// const [se07_scan] = useSound(se_07_scan);
// const [se08_se] = useSound(se_08);

// const { onScan, setPage, trueBarcode, setTrueBarcode } = props;

const ShoppingStartContext = useContext(ShoppingStart);
const [firstScan, setFirstScan] = useState(true);
//取得バーコード検証用
const [barcode, setBarcode] = useState();
// const scanFlgRef = useRef(props.scanFlg);
const { bandColor, updateBandColor } = useContext(SharedInfoContext);

//スキャン有効化
useEffect(() => {
	if(firstScan === true){
		setFirstScan(false);
	}else{
		console.log("props.scanFlg: " + props.scanFlg);
		// props.scanFlg true: スキャン不可 false:スキャン可
		if(props.scanFlg === false && firstScan === false){
			(async () => {
				setBarcode();
				if (loaded) {
					// await sdk.enableScanning(true);
					// await sdk.enableCamera(false);
					try {
						await sdk.enableScanning(true);
					} catch (e) {
						console.error("enableScanning failed:", e);

						// ユーザー向け表示
						props.setErrFlg(true);
						let err_msg = ";;"+e+";;;";
						props.setErr([true,``, err_msg]);

						// 再トライ暴発を避けたい場合はスキャン不可に戻す（任意）
						// props.setScanFlg(true);

						//ログアップロードAPI
						loguploadAPI(sharedInfo.transactionno, `scandit:enableScanning error, ${e}`);
					}
				}
			})();
		}
	}
}, [props.scanFlg]);


//----------------------------------------
//scanditエラー表示
//----------------------------------------

const sharedInfo = useContext(SharedInfoContext);

useEffect(() => {
	if(String(error).indexOf("NotAllowedError: Permission denied") !== -1){
		console.log("error: " + error);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_SCANDIT_NOTALLOW]);
		// props.setErr([true,``,`;;カメラの利用が許可されていません;;;`]);

		//ログアップロードAPI
		loguploadAPI(sharedInfo.transactionno,"scandit:error, " + error);

	}else if(String(error) !== "undefined" && String(error) !== undefined && String(error) !== ""){
		console.log("error: " + error);
		props.setErrFlg(true);
		let err_msg = ";;"+error+";;;";
		props.setErr([true,``, err_msg]);
		// props.setErr([true,``,`;;カメラの利用が許可されていません;;;`]);

		//ログアップロードAPI
		loguploadAPI(sharedInfo.transactionno,"scandit:error, " + error);
	}
}, [error]);


//----------------------------------------
//ログアップロードAPI
//----------------------------------------

const { loguploadAPI, data: loguploadData, loading: loguploadLoading, error: loguploadError } = useUserAPI();

//ログアップロードAPI：レスポンス
useEffect(() => {
	if(loguploadData){
		console.log(loguploadData);
		if (loguploadData.isSuccess == true) { //SUCCESS
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
		}else{ //ERROR
			console.log(`【loguploadAPI】 isSuccess: ${loguploadData.isSuccess}`);
			console.log(`【loguploadAPI】 errorCode: ${loguploadData.errorCode}`);
			console.log(`【loguploadAPI】 errorMessage: ${loguploadData.errorMessage}`);
		}
	}
}, [loguploadData]);


//----------------------------------------
//初期化
//----------------------------------------

useEffect(() => {
	setTimeout(function(){
		document.getElementById('scanBox').classList.add(`${styles.is_show}`);
	}, 100);

	// iOS16の場合に特定の処理を行う
	// if (isiOSVersion16()) { //iOS16：スキャンエリア設定
	// 	if(process.env.REACT_APP_IAEON_FLG === "true"){ //iAEON有効
	// 		setTimeout(function(){
	// 			(async () => {
	// 				const scannerArea = document.getElementById("barcode-scanner-area");
	// 				if (scannerArea) {
	// 					document.getElementById('scanBox').classList.add(`${styles.is_show}`);
	// 					const rect = scannerArea.getBoundingClientRect();
	// 					const viewRect = document.getElementById("barcode-scanner").getBoundingClientRect();
	// 					await sdk.setScanArea(rect,viewRect);
	// 				}
	// 			})();
	// 		}, 600);
	// 	}else { //iAEON無効
	// 		setTimeout(function(){
	// 			document.getElementById('scanBox').classList.add(`${styles.is_show}`);
	// 		}, 300);
	// 	}
	// } else { //スキャンエリア設定
	// 	setTimeout(function(){
	// 		(async () => {
	// 			const scannerArea = document.getElementById("barcode-scanner-area");
	// 			if (scannerArea) {
	// 				document.getElementById('scanBox').classList.add(`${styles.is_show}`);
	// 				const rect = scannerArea.getBoundingClientRect();
	// 				const viewRect = document.getElementById("barcode-scanner").getBoundingClientRect();
	// 				await sdk.setScanArea(rect,viewRect);
	// 			}
	// 		})();
	// 	}, 600);
	// }

	//arrows We 対応
	// document.documentElement.style.zoom = window.innerWidth / 390;
	// var zratio = window.innerWidth / 390;
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('scan');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}

}, []);


useEffect(() => {
	//お買物API：画面遷移API（スキャン画面
	props.okaimonoAPI_didScreenTransition("scan_item");
}, []);


//----------------------------------------
//商品登録API
//----------------------------------------

const { shoppingPurchaseAPI, data: shoppingPurchaseData, loading: shoppingPurchaseLoading, error: shoppingPurchaseError, scnflg: shoppingPurchaseScanFlg } = useUserAPI();
//API を呼び出せる状態かを管理するフラグ：初期値は true で、API を呼び出すたびに false に設定し、タイマーで 1 秒後に true に戻す
const [isApiCallAllowed, setIsApiCallAllowed] = useState(true);

//商品登録API：呼び出し制限
useEffect(() => {
	console.log("barcode: " + barcode);
	console.log("isApiCallAllowed: " + isApiCallAllowed);
    if (barcode && isApiCallAllowed && !shoppingPurchaseLoading) {
        console.log("【商品登録API call】---------------------------");
        shoppingPurchaseAPI(barcode, ShoppingStartContext.data.token);
        console.log("【/商品登録API call】---------------------------");

        // API呼び出し制御をfalseにし、1秒後にtrueに戻す
        setIsApiCallAllowed(false);
        const timer = setTimeout(() => {
            setIsApiCallAllowed(true);
        }, 1000);

        // クリーンアップ関数でタイマーを解除
        return () => clearTimeout(timer);
    }else {
        console.log("【商品登録API call】再呼び出し制限中");
	}
}, [barcode]);

// useEffect(() => {
// 	if(barcode){
// 		console.log("【商品登録API call】---------------------------");
// 		shoppingPurchaseAPI(barcode,ShoppingStartContext.data.token);
// 		console.log("【/商品登録API call】---------------------------");
// 	}
// }, [barcode]);

//商品登録API：レスポンス
useEffect(() => {

	let timeoutId;

	// console.log("useEffect purchaseData");
	if(shoppingPurchaseData){
		// console.log("ああああ");
		if (shoppingPurchaseData.data) { //SUCCESS

			// let newcode = "922800001549017772476801";
			let newcode = "";

			if (barcode.length === 24) { //24桁
				console.log("スキャン商品情報取得API：barcode変換前：24桁");
				var excode = barcode.substring(10, 23); //11桁目〜23桁目のコードを抽出
				console.log("スキャン商品情報取得API：11桁目〜23桁目のコードを抽出");
				if (excode.length === 13) { //13桁
					console.log("スキャン商品情報取得API：13桁");
					if (excode.substring(0, 2) === "02" || excode.substring(0, 2) === "04" || excode.substring(0, 2) === "27" || excode.substring(0, 2) === "29") { //先頭2桁が02,04,27,29の場合
						console.log("スキャン商品情報取得API：先頭2桁が02,04,27,29の場合");
						newcode = excode.substring(0, 7) + "000000"; //13桁の下6桁を全て0にする
					} else { //それ以外
						console.log("スキャン商品情報取得API：それ以外");
						newcode = excode;
					}
				} else if (excode.length <= 8) { //8桁以下
					console.log("スキャン商品情報取得API：8桁以下");
					if (excode.charAt(0) !== "0") { //先頭が0でない場合
						console.log("スキャン商品情報取得API：先頭が0でない");
						newcode = excode;
					} else { //先頭が0の場合
						console.log("スキャン商品情報取得API：先頭が0");
						newcode = excode.substring(1, excode.length - 1).padEnd(6, "0"); //1桁目の0をカットし末尾1桁を削り6桁にする
					}
				}
			} else if (barcode.length === 13) { //13桁
				console.log("スキャン商品情報取得API：barcode変換前：13桁");
				if (barcode.substring(0, 2) === "02" || barcode.substring(0, 2) === "04" || barcode.substring(0, 2) === "27" || barcode.substring(0, 2) === "29") { //先頭2桁が02,04,27,29の場合
					console.log("スキャン商品情報取得API：先頭2桁が02,04,27,29の場合");
					newcode = barcode.substring(0, 7) + "000000"; //13桁の下6桁を全て0にする
				} else { //それ以外
					console.log("スキャン商品情報取得API：それ以外");
					newcode = barcode;
				}
			} else if (barcode.length <= 8) { //8桁以下
				console.log("スキャン商品情報取得API：barcode変換前：8桁以下");
				if (barcode.charAt(0) !== "0") { //先頭が0でない場合
					console.log("スキャン商品情報取得API：先頭が0でない");
					newcode = barcode;
				} else { //先頭が0の場合
					console.log("スキャン商品情報取得API：先頭が0");
					newcode = barcode.substring(1, barcode.length - 1).padEnd(6, "0"); //1桁目の0をカットし末尾1桁を削り6桁にする
				}
			}

			if(newcode !== ""){
				console.log("スキャン商品情報取得API：barcode変換後：" + newcode);
				//お買物API：スキャン商品情報取得API（バーコード、カテゴリーコード、部門コード
				okaimonoAPI_didScanInformation(newcode,shoppingPurchaseData.data.categoryCode,shoppingPurchaseData.data.departmentCode);
			}

			// se07_scan();
			props.setSoundState("se07_scan");

			console.log(`【shoppingPurchaseAPI】 receiptKanji: ${shoppingPurchaseData.data.receiptKanji}`);
			console.log(`【shoppingPurchaseAPI】 sellPrice: ${shoppingPurchaseData.data.sellPrice}`);
			console.log(`【shoppingPurchaseAPI】 discountSellPrice: ${shoppingPurchaseData.data.discountSellPrice}`);
			console.log(`【shoppingPurchaseAPI】 categoryCode: ${shoppingPurchaseData.data.categoryCode}`);
			console.log(`【shoppingPurchaseAPI】 departmentCode: ${shoppingPurchaseData.data.departmentCode}`);

			props.setShoppingData(shoppingPurchaseData);
			setScanItem(true);

			//お買物API：画面遷移API（ポップアップ表示
			props.okaimonoAPI_didScreenTransition("popup");

			// バージョン比較（"12.6.0"未満か判定）
			const isVersionLower = (a, b) => {
				const pa = String(a).split('.').map(n => parseInt(n, 10) || 0);
				const pb = String(b).split('.').map(n => parseInt(n, 10) || 0);
				const len = Math.max(pa.length, pb.length);
				for (let i = 0; i < len; i++) {
					const na = pa[i] ?? 0;
					const nb = pb[i] ?? 0;
					if (na < nb) return true;
					if (na > nb) return false;
				}
				return false;
			};

			if(isVersionLower(props.appVersion, "12.6.0")){ //12.6.0未満の場合
				console.log("【BarcodeScanner】appVersion12.6.0未満のため通常の終了動作（2.5秒後に買物一覧へ遷移");
				setTimeout(function(){
					// setTrueBarcode("");
					setScanItem(false);
					// props.setScanFlg(false);
					(async () => {
						if (loaded) {
							// await sdk.enableScanning(true);
							await sdk.enableCamera(false);
						}
					})();
					document.getElementById('scanBox').classList.remove(`${styles.is_show}`);
					props.setPage("shopping");
				}, 2500);

			}else{ //12.6.0以上の場合
				console.log("【BarcodeScanner】appVersion12.6.0以上のためcallCloseScanAPIにより買物一覧へ遷移");

				//タイムアウト処理：callCloseScanAPIがコールされない場合、7秒後に買物一覧へ遷移
				timeoutId = setTimeout(function(){
					if(props.page === "scan"){
						console.log("タイムアウト処理：callCloseScanAPIがコールされない場合、7秒後に買物一覧へ遷移");
						//お買物APIからのスキャン画面終了API（25.12.06追加
						appCloseScan();
					}
				}, 7000);

				//テストコール
				// setTimeout(function(){
				// 	//お買物APIからのスキャン画面終了API（25.12.06追加
				// 	appCloseScan();
				// }, 5000);
			}

		}else{ //ERROR
			// console.log("うううう");
			console.log(`【shoppingPurchaseAPI】 errorCode: ${shoppingPurchaseData.errorCode}`);
			console.log(`【shoppingPurchaseAPI】 errorMessage: ${shoppingPurchaseData.errorMessage}`);
			console.log(`【shoppingPurchaseAPI】 isSuccess: ${shoppingPurchaseData.isSuccess}`);

			// se07_scan();
			props.setSoundState("se07_scan");
			// (async () => {
			// 	await sdk.enableScanning(false);
			// 	// await sdk.enableCamera(false);
			// })();

			if(shoppingPurchaseData.errorCode === "26"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${shoppingPurchaseData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_26]);
				// props.setErr([true,`${shoppingPurchaseData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[26];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[26]`]);
			}else if(shoppingPurchaseData.errorCode === "27"){
				//トークン不正、トークン有効期限切れ のためエラー表示後にアプリ起動後の画面へ（再読込
				props.setErrFlg(true);
				props.setErr([true,`${shoppingPurchaseData.errorCode}`, process.env.REACT_APP_ERROR_MESSAGE_27]);
				// props.setErr([true,`${shoppingPurchaseData.errorCode}`,`i1b0;認証エラー;申し訳ございません。正常に処理が終了いたしませんでした。買い物を中止して、最初から操作しなおしてください。[27];Authentication Error;The authentication has expired or was invalid. Please tap to start the process again.[27]`]);
			}else{
				// props.setErrNum(`${shoppingPurchaseData.errorCode}`);
				// props.setShowModal(true);
				// props.setErrTxt(`${shoppingPurchaseData.errorMessage}`);
				props.setErrFlg(true);
				props.setErr([true,`${shoppingPurchaseData.errorCode}`,`${shoppingPurchaseData.errorMessage}`]);

				// console.log("barcodeCapture");
				// console.log(barcodeCapture);
				// setTimeout(function(){
					// if(barcodeCapture){
					// 	// barcodeCapture.addListener(listener);
					// 	barcodeCapture.setEnabled(true);
					// }
					// console.log("【scandit】restart");
					// initScann();
					// props.setScanFlg(false);
				// }, 2200);
			}
		}
	}
	if(shoppingPurchaseError){
		console.log("shoppingPurchaseError");
		console.log(shoppingPurchaseError);
		props.setErrFlg(true);
		props.setErr([true,``, process.env.REACT_APP_ERROR_MESSAGE_TIMEOUT]);
		// props.setErr([true,``,`;通信エラー;サーバーからの応答がありませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
		// props.setErr([true,``,`;通信エラー;データを送信できませんでした。一定時間を置いて再度お試しいただくか電波状況の良い環境で再度お試しください。ご不便をおかけし申し訳ありません。;;;`]);
	}
	if(shoppingPurchaseLoading){
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.add('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.add('is_show');
		});
	}else{
		document.querySelectorAll('.loadingBox01').forEach(function(element) {
			element.classList.remove('is_show');
		});
		document.querySelectorAll('.loadingBox01_cover').forEach(function(element) {
			element.classList.remove('is_show');
		});
	}
	// if(shoppingPurchaseScanFlg === true){
	// 	props.setScanFlg(false);
	// }
	return () => {
		if (timeoutId) clearTimeout(timeoutId);
	};
}, [shoppingPurchaseData,shoppingPurchaseLoading,shoppingPurchaseError,shoppingPurchaseScanFlg]);


//お買物APIからのスキャン画面終了（25.12.06追加
const appCloseScan = () => {
	setScanItem(false);
	(async () => {
		if (loaded) {
			// await sdk.enableScanning(true);
			await sdk.enableCamera(false);
		}
	})();
	document.getElementById('scanBox').classList.remove(`${styles.is_show}`);
	props.setPage("shopping");
}

// 親(App)から呼べるよう公開
useImperativeHandle(ref, () => ({
	appCloseScan,
}));


//----------------------------------------
//スキャン閉じる（買物一覧画面へ
//----------------------------------------

const onScanClose = async () => {
	(async () => {
		if (loaded) {
			await sdk.enableScanning(false);
			await sdk.enableCamera(false);
		}
	})();
	document.getElementById('scanBox').classList.remove(`${styles.is_show}`);

	// setScanItem(false);
	props.setPage("shopping");
	// se08_se();
	props.setSoundState("se08_se");
}

const [scanItem, setScanItem] = useState(false)

const motionConfig = {
	initial: {
		y: -20,
		opacity: 0,
	},
	animate: {
		y: 0,
		opacity: 1,
	},
	hidden: {
		y: 20,
		opacity: 0,
	},
};


//----------------------------------------
//お買物API：スキャン商品情報取得API
//----------------------------------------

const okaimonoAPI_didScanInformation = async (bcode,ccode,dcode) => {
	try {
		console.log("----------------------------");
		console.log("【didScanInformation】call");

		// const { callbackId, result } = await callOkaimonoAPI('didScanInformation', { janCode: '4901234567894', categoryCode: 'A1', departmentCode: 'B2' });
		const { callbackId, result } = await callOkaimonoAPI('didScanInformation', { janCode: bcode, categoryCode: ccode, departmentCode: dcode });

		console.log("callbackId:", callbackId);
		console.log("result:", result);
		if (result.result === "1") {
			console.log("【didScanInformation】success", result);
			console.log("【didScanInformation】result:", result.result);

		}else {
			console.log("【didScanInformation】error", result);
			console.log("【didScanInformation】result:", result.result);
		}

	} catch (error) {
		console.log('【didScanInformation】error', error);
	}
};


return (
<div id="scan" className="container l_contents">

<header id="header02" className={`l_header02 ${bandColor}`}>
	<div href="" className="header02_backBtn" onClick={onScanClose}>
		<img src="/images/icn_back01_white.svg" alt="" width="24" height="24"/>
	</div>
	<p className="header02_tit">スキャン中</p>
</header>

<div className={styles.msgBox}>
	<p className={styles.msgBox_txt}>商品のバーコードを<br/>枠内に入れてください</p>
</div>

<div id="scanBox" className={styles.scanBox}>
	<div id="barcode-scanner-area" className={styles.scanArea}></div>
	<div className={styles.scanBoxBlack}></div>
	<div className={styles.scanCover}></div>
	<div id="barcode-scanner" className={`${styles.scanImg} ${styles.scanImg02}`}></div>
	<ScannerComponent setBarcode={setBarcode} setScanFlg={props.setScanFlg}/>
</div>

<AnimatePresence>
	{scanItem && (
		// {setScanItem ? ( // showModalがtrueだったらModal表示
		// if(shoppingPurchaseData){ // showModalがtrueだったらModal表示
		<motion.div id="addItem" className={styles.addItem}
		initial={'initial'}
		animate={'animate'}
		exit={'hidden'}
		variants={motionConfig}
		transition={{duration: 0.4, ease: 'easeOut'}}
		>
				<div className={styles.addItem_head}>
					<p className={styles.addItem_head_txt}>
						<span className={styles.addItem_head_check}>
							<img src="/images/icn_check_aeon.svg" alt="" width="24" height="24" />
						</span>
						商品を追加しました
					</p>
				</div>
				<div className={styles.addItem_box}>
					<div className={styles.addItem_in}>
						<div className={styles.addItem_img}>
							{/* <img src="/images/img_item02.png" alt="" width="40" height="40"/> */}
							<img src={shoppingPurchaseData.data.itemUrl ? shoppingPurchaseData.data.itemUrl : '/images/noimage.png'} alt="" width="40" height="40"/>
							{/* <img src={shoppingPurchaseData.data.itemUrl} alt="" width="40" height="40"/> */}
						</div>
						<p className={styles.addItem_name}>{shoppingPurchaseData.data.receiptKanji}</p>
						{/* <p className={styles.addItem_name}>トップバリュ 糖質をおさえたブランデニッシュ 2個入</p> */}
						<div className={styles.addItem_priceBox}>
							<p className={styles.addItem_price}>
								<span className={`${styles.addItem_price_default} ${shoppingPurchaseData.data.discountSellPrice ? styles.cancel : ''}`}><small>¥</small>
								{
									(() => {
										return (
											(shoppingPurchaseData.data.sellPrice).toLocaleString('ja-JP')
										)
										// if (shoppingPurchaseData.data.discountSellPrice != null) {
										// 	return shoppingPurchaseData.data.discountSellPrice;
										// } else {
										// 	return shoppingPurchaseData.data.sellPrice;
										// }
									})()
								}
								</span>

								{/* <span className="addItem_price_default cancel"><small>¥</small>198</span> */}
							</p>
						</div>
					</div>
					{
						(() => {
							if (shoppingPurchaseData.data.discountType === 1) {
								return(
									<div className={styles.addItem_discount}>
										<p className={styles.addItem_discount_txt}>レジにて<strong>{(shoppingPurchaseData.shoppingPurchaseData.data.discountAmount).toLocaleString('ja-JP')}</strong>円引き</p>
										<p className={styles.addItem_discount_price}><small>¥</small>{(shoppingPurchaseData.data.discountSellPrice).toLocaleString('ja-JP')}</p>
									</div>
								)
							}else if (shoppingPurchaseData.data.discountType === 2) {
								return(
									<div className={styles.addItem_discount}>
										<p className={styles.addItem_discount_txt}>レジにて<strong>{shoppingPurchaseData.data.discountAmount}</strong>%OFF</p>
										<p className={styles.addItem_discount_price}><small>¥</small>{(shoppingPurchaseData.data.discountSellPrice).toLocaleString('ja-JP')}</p>
									</div>
								)
							}else if (shoppingPurchaseData.data.discountType === 3) {
								return(
									<div className={styles.addItem_discount}>
										<p className={styles.addItem_discount_txt}>レジにて</p>
										<p className={styles.addItem_discount_price}><small>¥</small>{(shoppingPurchaseData.data.discountSellPrice).toLocaleString('ja-JP')}</p>
									</div>
								)
							}
						})()
					}
					{/* <div className="addItem_discount">
						<p className="addItem_discount_txt">レジにて<strong>30</strong>%OFF</p>
						<p className="addItem_discount_price"><small>¥</small>138</p>
					</div> */}

				</div>
		</motion.div>
		// }
	)}
</AnimatePresence>
</div>
		// </>
)
})

export default BarcodeScanner
